const refundETA = "5-8"
const replacementETA = "5-8"

export { refundETA, replacementETA }